// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.left {
  float: left;
  width: 6%;
  height: 100%;
}

.right {
  float: right;
  width: 92%;
}

.success-message {
  color: #007a3e;
  display: inline-block;
  width: 100%;
}
.success-message h2 {
  margin: 9px 0px 0px 50px;
  font: 2.4rem "Omnes-ATT-W02";
  color: #007a3e !important;
}
.success-message p {
  margin-top: 15px;
  margin-bottom: 0px;
}

.icon-approval {
  color: #007a3e;
  font-size: 35px;
  line-height: 1.1;
}

.icon-controls-approvalL {
  color: #007a3e !important;
  font-size: 51px;
}

.separator {
  margin: 0 10px;
}

.outer {
  margin: 30px 0;
}

.heading {
  margin: 20px 0px;
}

.review-container {
  margin: auto;
}

.cta {
  padding: 30px 0 60px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/report/transaction/confirmation/confirmation.component.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,SAAA;EACI,YAAA;AACR;;AACA;EACI,YAAA;EACA,UAAA;AAEJ;;AACA;EACE,cAAA;EACA,qBAAA;EACA,WAAA;AAEF;AADE;EACE,wBAAA;EACA,4BAAA;EACA,yBAAA;AAGJ;AADE;EACE,gBAAA;EACA,kBAAA;AAGJ;;AAAA;EACM,cAAA;EACF,eAAA;EACA,gBAAA;AAGJ;;AADA;EACE,yBAAA;EACA,eAAA;AAIF;;AAFA;EACE,cAAA;AAKF;;AAFA;EACE,cAAA;AAKF;;AAFA;EACE,gBAAA;AAKF;;AAFA;EACE,YAAA;AAKF;;AADA;EACE,oBAAA;AAIF","sourcesContent":[".left {\n    float: left;\n    width: 6%;\n        height: 100%;\n}\n.right{\n    float: right;\n    width: 92%;\n}\n\n.success-message {\n  color:  #007a3e;\n  display: inline-block;\n  width: 100%;\n  h2{\n    margin: 9px 0px 0px 50px;\n    font: 2.4rem 'Omnes-ATT-W02';\n    color: #007a3e !important;\n  }\n  p {\n    margin-top: 15px;\n    margin-bottom: 0px;\n  }\n}\n.icon-approval{\n      color: #007a3e;\n    font-size: 35px;\n    line-height: 1.1;\n}\n.icon-controls-approvalL{\n  color: #007a3e !important;\n  font-size: 51px;\n}\n.separator {\n  margin: 0 10px;\n}\n\n.outer {\n  margin: 30px 0;\n}\n\n.heading{\n  margin: 20px 0px;\n}\n\n.review-container {\n  margin: auto;\n  // width: 47%;\n}\n\n.cta {\n  padding: 30px 0 60px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
